export default __webpack_public_path__ + "static/media/Button_Disclosure_Right.88a950ab.svg";